import Stats from "./Stats/Stats";

const Dashboard = () => {
  return (
    <div>
      <Stats />
    </div>
  );
};

export default Dashboard;
